import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { CroppedImageView } from '@bingads-webui-campaign-react/cropped-image-view';
import type { UAPPlacementComponentProps } from '../../@types';

import { withUAPLThemedStyles } from '../../with-themed-styles';
import { getBoostDiscoverCard1x1Styles } from '../../styles';
import {
  MMAPlacementCard,
  PlacementHeadline,
  PlacementDescription,
  PlacementAction,
} from '../../shared-components';

const BoostDiscoverCard1x1 = ({
  // UAPVMSingleImagePlacement
  placementData,

  isEnabled,
  finalUrl,
  shortHeadline,
  description,
  callToAction,
  i18n,
  classes,
}: UAPPlacementComponentProps) => {
  const {
    placementMeta, placementCropping, imageMeta, effectiveImageUrl, effectiveImageWidth, effectiveImageHeight, expandedPlacementCropping,
  } = placementData || {};
  const { previewHeight, aspectRatio } = placementMeta || {};
  if (!placementData || !imageMeta) {
    return null;
  }

  // const srcForCroppedImageView = showImage && this.props.image.FinalSrc;
  const imagePreviewWidth = previewHeight * aspectRatio;

  const cropping = expandedPlacementCropping || placementCropping;

  return (
    <MMAPlacementCard url={finalUrl} width={imagePreviewWidth} isEnabled={isEnabled} mmaPlacementCardClassName={classes.placementCard}>
      <div className={classnames(classes.placementImageContainer)}>
        {
          imageMeta.url &&
          <CroppedImageView
            resizeImageHeight={previewHeight}
            aspectRatio={aspectRatio}
            src={effectiveImageUrl || imageMeta.url}
            originalWidth={effectiveImageWidth || imageMeta.originalWidth}
            originalHeight={effectiveImageHeight || imageMeta.originalHeight}
            SourceX={cropping && cropping.SourceX}
            SourceY={cropping && cropping.SourceY}
            SourceWidth={cropping && cropping.SourceWidth}
            SourceHeight={cropping && cropping.SourceHeight}
          />
        }
      </div>
      <div className="hardcode-discover">{i18n.getString(_TL_('Discover'))}</div>
      <div className={classnames(classes.placementTextContainer)}>
        <PlacementHeadline

          headlineText={shortHeadline}
          isMultiLine
          placementHeadlineClassName={classnames(classes.placementShortHeadline, 'short-headline')}
        />
        <PlacementDescription

          description={description}
          placementDescriptionClassName={classnames(classes.placementDescription, 'description')}
        />
        {callToAction && ( // add a space before each capital letter, e.g. "ActNow" => "Act Now"
          <PlacementAction actionText={callToAction.replace(/([A-Z])/g, ' $1')} placementActionClassName={classes.placementCallToAction} />
        )}
      </div>
    </MMAPlacementCard>
  );
};

BoostDiscoverCard1x1.propTypes = {
  placementData: PropTypes.shape({}).isRequired, // UAPVMSingleImagePlacement
  isEnabled: PropTypes.bool,
  shortHeadline: PropTypes.string,
  finalUrl: PropTypes.string,
  description: PropTypes.string,
  callToAction: PropTypes.string,
  i18n: PropTypes.shape({}).isRequired,
  classes: PropTypes.shape({}).isRequired,
};

BoostDiscoverCard1x1.defaultProps = {
  isEnabled: true,
  shortHeadline: undefined,
  finalUrl: undefined,
  description: undefined,
  callToAction: undefined,
};

export const AdPlacementBoostDiscoverCard1x1 = withUAPLThemedStyles(
  BoostDiscoverCard1x1,
  getBoostDiscoverCard1x1Styles,
  { componentName: 'AdPlacementBoostDiscoverCard1x1' }
);
